import * as React from "react";
import { useParams, useLocation } from "@reach/router";

import { PolicyConfirmed } from "../components";

export const PolicyConfirmationPage: React.FC = () => {
  const { riskProfileId } = useParams();
  const location = useLocation();
  React.useEffect(() => {
    // Push current page to history to keep user in current page on browser back click
    history.pushState(null, null, location.pathname);
  });
  return <PolicyConfirmed riskProfileId={riskProfileId} />;
};
